import React from "react";
import { Container } from "react-bootstrap";
import ProjectCards from "./ProjectCards";
import projectsData from "../../data/projects/projectsData";
import "./Projects.css";

function Projects() {
  return (
    <section className="projects-section" id="projects">
      <Container>
        <header className="projects-header">
          <span>Selected projects</span>
          <h2>Enterprise infrastructure and <strong>cybersecurity</strong></h2>
          <p>
            Major implementations from the enterprise environment, presented with
            concise explanations and practical evidence.
          </p>
        </header>

        <div className="projects-grid">
          {projectsData.map((project) => (
            <ProjectCards key={project.id} project={project} />
          ))}
        </div>
      </Container>
    </section>
  );
}

export default Projects;
